import React, { useState, useEffect } from 'react';
import {
  DashboardOutlined,
  DownloadOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  NotificationOutlined,
  ProfileFilled,
  UploadOutlined,
  UserOutlined,
  BellOutlined,
  MailFilled,
  WindowsFilled,
  MailOutlined
} from '@ant-design/icons';
import { App, Button, Layout, Menu } from 'antd';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import Logo1 from "../assests/Culsight Logo - Negative (1).png";
import Logo2 from "../assests/Culsight Logo (1) (1).png";
import { getUser, logout } from '../../authService';
import UserDropdown from '../components/UserDropdown';
import ThemeSetting from '../components/ThemeSetting';

const { Header, Sider, Content } = Layout;

const MasterTemplate = () => {
  const { modal } = App.useApp()
  const [user, setUser] = useState(null);
  const [master_loder, set_master_loder] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);
  const [balck_theme, set_balck_theme] = useState(false);




  useEffect(() => {

    getUser().then(usr => {
      // console.log(usr)
      setUser(usr);
      set_master_loder(false)
    });
  }, []);


  useEffect(() => {
    const pathToKey = {
      '/': { selected: '1' },
      '/learners': { selected: '3', open: '2' },
      '/add-learner': { selected: '3', open: '2' },
      '/edit-learner': { selected: '3', open: '2' },
      '/learners-group': { selected: '12', open: '2' },
      '/assign-learner': { selected: '12', open: '2' },
      '/instructors': { selected: '4', open: '2' },
      '/add-instructors': { selected: '4', open: '2' },
      '/import-instructors': { selected: '4', open: '2' },
      '/courses': { selected: '6', open: '5' },
      '/add-courses': { selected: '6', open: '5' },
      '/edit-course': { selected: '6', open: '5' },
      '/course-learners': { selected: '6', open: '5' },
      '/learner-report': { selected: '6', open: '5' },
      '/packages': { selected: '7', open: '5' },
      '/add-packages': { selected: '7', open: '5' },
      '/edit-package': { selected: '7', open: '5' },
      '/media': { selected: '8' },
      '/report': { selected: '9' },
      '/download': { selected: '10' },
      '/notification': { selected: '13' },
      '/add-notification': { selected: '13', open: '13' },
      '/edit-notification': { selected: '13', open: '13' },
      '/smtp': { selected: '16' },
      '/add-smtp': { selected: '16', open: '16' },
      '/edit-smtp': { selected: '16', open: '16' },
      '/announcements': { selected: '15' },
      '/add-announcement': { selected: '15', open: '15' },
      '/edit-announcement': { selected: '15', open: '15' },
      '/deleted-courses': { selected: '14', open: '5' },
      '/microsoft': { selected: '18', open: '17' },
      '/add-microsoft': { selected: '18', open: '17' },
      '/edit-microsoft': { selected: '18', open: '17' },
      '/pre-email-template': { selected: '19', open: '19' },
      '/add-pre-email-template': { selected: '19', open: '19' },
      '/edit-pre-email-template': { selected: '19', open: '19' },
      '/sub-admin': { selected: '20', open: '2' },
      '/add-sub-admin': { selected: '20', open: '2' },
      '/edit-sub-admin': { selected: '20', open: '2' },

    };
    const path = location.pathname;
    const match = pathToKey[path];
    if (match) {
      setSelectedKeys([match.selected]);
      if (match.open) {
        setOpenKeys([match.open]);
      } else {
        setOpenKeys([]);
      }
    }
    set_balck_theme(0);

  }, [location.pathname]);


  const handleMenuClick = ({ key }) => {
    const keyToPath = {
      '1': '/',
      '3': '/learners',
      '4': '/instructors',
      '6': '/courses',
      '7': '/packages',
      '8': '/media',
      '9': '/report',
      '10': '/download',
      '12': '/learners-group',
      '13': '/notification',
      '14': '/deleted-courses',
      '15': '/announcements',
      '16': '/smtp',
      '18': '/microsoft',
      '19': '/pre-email-template',
      '20': '/sub-admin'


    };


    const route = keyToPath[key];
    if (route) {
      clearPageStorage()
      navigate(route);
    } else if (key === '50') {
      modal.confirm({
        title: "Are you sure you want to logout?",
        okText: "Logout",
        cancelText: "Cancel",
        onOk: () => {
          logout();
        },
      });
    }
  };



  const onOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  if (!user) {
    return <Navigate path="/" />
  }


  const clearPageStorage = (currentRoute) => {
    const pageStorageKeys = {
      "/courses": [
        "course_search_field",
        "course_search_query",
        "course_page_size",
        "course_page",
        "course_last_search_page",
        "course_title",
      ],

      "/packages": [
        "package_last_search_page",
        "package_search_query",
        "package_page",
      ],

      "/learners": [
        "learner_last_search_page",
        "learner_search_value",
        "learner_page",
        "learner_search_key",
      ],

      "/media": [
        "video_last_search_page",
        "video_search",
        "video_page",
      ],

      "/pre-email-template": [
        "pre_email_last_search_page",
        "pre_email_search",
        "pre_email_page",
      ],

      "/notification": [
        "notification_last_search_page",
        "notification_search",
        "notification_page",
      ],

      "/smtp": [
        "smtp_last_search_page",
        "smtp_search",
        "smtp_page",
      ],

      "/announcment": [
        "announcement_last_search_page",
        "announcement_search",
        "announcement_page",
      ],

      "/report": [
        "course_report_last_search_page",
        "course_report_search",
        "course_report_page",
        "package_report_last_search_page",
        "package_report_search",
        "package_report_page",
        "live_test_last_search_page",
        "live_test_search",
        "live_test_page",
        "quiz_report_last_search_page",
        "quiz_report_search",
        "quiz_report_page",
        "course_quiz_report_last_search_page",
        "course_quiz_report_search",
        "course_quiz_report_page",
      ],
      "/download": [
        "course_download_last_search_page",
        "course_download_search",
        "course_download_page",
        "package_download_last_search_page",
        "package_download_search",
        "package_download_page",
        "quiz_download_last_search_page",
        "quiz_download_search",
        "quiz_download_page",
        "course_quiz_download_last_search_page",
        "course_quiz_download_search",
        "course_download_page"

      ],

      "microsoft": [
        "microsoft_last_search_page",
        "microsoft_search",
        "microsoft_page",
      ],
    };

    Object.entries(pageStorageKeys).forEach(([route, keys]) => {
      if (route !== currentRoute) {
        keys.forEach((key) => localStorage.removeItem(key));
      }
    });
  };


  return (
    <>
      {master_loder ? <>
        Loading...........
      </> : <>
        <Layout style={{ minHeight: '100vh' }}>
          <Sider trigger={null} collapsible collapsed={collapsed} width={230} collapsedWidth={80} style={balck_theme ? { background: "#141414" } : { background: "#fff" }}
          >
            <div className='menu-logo'>
              <img
                alt="logo"
                src={balck_theme ? Logo1 : Logo2}
              />
            </div>

            <Menu
              mode="inline"
              selectedKeys={selectedKeys}
              openKeys={openKeys}
              onOpenChange={onOpenChange}
              onClick={handleMenuClick}
              items={[
                {
                  key: '1',
                  icon: <DashboardOutlined />,
                  label: 'Dashboard',
                },
                {
                  key: '2',
                  icon: <UserOutlined />,
                  label: 'Users',
                  children: [
                    { key: '20', label: "Sub Admin" },
                    { key: '3', label: "Learners" },
                    { key: '12', label: "Learners Group" },

                    // { key: '4', label: "Instructors" }
                  ]
                },
                {
                  key: '5',
                  icon: <FileTextOutlined />,
                  label: 'Content',
                  children: [
                    { key: '6', label: "Courses" },
                    { key: '14', label: "Deleted Courses" },
                    { key: '7', label: "Packages" },

                  ]
                },
                {
                  key: '8',
                  icon: <ProfileFilled />,
                  label: 'Media',
                },

                {
                  key: '19',
                  icon: <MailOutlined />,
                  label: 'Pre Define Email Template',
                },

                {
                  key: '13',
                  icon: <BellOutlined />,
                  label: 'Notifcation',
                },

                {
                  key: '16',
                  icon: <MailFilled />,
                  label: 'Smtp',
                },

                {
                  key: '15',
                  icon: <NotificationOutlined />,
                  label: 'Announcements',
                },

                {
                  key: '9',
                  icon: <FileSearchOutlined />,
                  label: 'Report',
                },

                {
                  key: "10",
                  icon: <DownloadOutlined />,
                  label: 'Download',
                },


                {
                  key: '17',
                  icon: <WindowsFilled />,
                  label: 'SSO',
                  children: [
                    { key: '18', label: "Microsoft" },


                  ]
                },
                // {
                //   key: '11',
                //   icon: <SettingFilled />,
                //   label: 'Setting',
                // },
                {
                  key: '50',
                  icon: <UploadOutlined />,
                  label: 'Logout',
                },
              ]}
            />
          </Sider>
          <Layout>
            <Header
              style={
                balck_theme
                  ? {
                    padding: "0 10px",
                    backgroundColor: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    color: "#fff",
                  }
                  : {
                    padding: "0 10px",
                    backgroundColor: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    color: "#141414",
                  }
              }
            ><div>
                <Button
                  type="text"
                  icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                  onClick={() => setCollapsed(!collapsed)}
                  style={{
                    fontSize: '16px',
                    width: 64,
                    height: 64,
                    color: balck_theme ? "#fff" : "#141414",
                  }}
                />
                <span style={{ fontWeight: "bold", fontSize: "20px" }}>Admin Panel</span>
              </div>
              <div style={{ gap: "20px", display: "flex" }}>
                {/* <ThemeSetting set_theme_style={set_balck_theme} /> */}

                <UserDropdown user={user} />
              </div>

            </Header>
            <Content style={
              balck_theme
                ? { backgroundColor: "#f4f4f4" }
                : { backgroundColor: "#f4f4f4" }
            }
            >
              <Outlet context={{ user, setUser }} />
            </Content>
          </Layout>
        </Layout>
      </>}
    </>
  );
};

export default MasterTemplate;
